// components/SEO.tsx
import Head from "react-helmet";

interface SEOProps {
  title: string;
  description: string;
  image?: string;
  favicon?: string; // Peut être .ico ou .png
}

export default function SEO({ title, description, image, favicon }: SEOProps) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}

      {/* Favicon dynamique */}
      {favicon && <link rel="icon" href={favicon} type={favicon.endsWith(".png") ? "image/png" : "image/x-icon"} />}
    </Head>
  );
}
